
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWiper as ObiWiperElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wiper.js';
 
 
 

 
 export const ObiWiper = createComponent({
   react: React,
   tagName: 'obi-wiper',
   elementClass: ObiWiperElement,
   events: {
     
   }
  });
 
 